import React, { useContext } from 'react'
import { Route, Routes, useMatch } from 'react-router-dom'
import { ConfigContext } from 'src/store/ConfigContext'

import HPAllInDeviceOnboarding from './HPAllInDeviceOnboarding'

const App = () => {
  const { localization } = useContext(ConfigContext)
  const match = useMatch('/:country/:language/*')
  return (
    <Routes>
      <Route
        path={`${
          localization.enabled && match ? match.pathnameBase : ''
        }/hp-all-in-device-onboarding/*`}
        element={<HPAllInDeviceOnboarding />}
      />
    </Routes>
  )
}

export default App
